/**
 * Field wrapper for Dragon theme
 */
export enum ISPFieldWrapper {
  Page = 'page',
  InputBase = 'input-base',
  FieldBase = 'field-base',
  ValidationError = 'validation-error',
}
